import React from "react";
import "./Modal.scss";
import { Link } from "react-router-dom";
import Drawer from "@mui/material/Drawer";

export default function AadhaarExistModal(props) {
  const { openAadhaarModal, setOpenAadhaarModal } = props;

  return (
    <div>
      <Drawer
        anchor="bottom"
        open={openAadhaarModal["bottom"]}
        onClose={() => setOpenAadhaarModal({ ...openAadhaarModal, bottom: false })}
      >
        <div className="exist__modal">
          <img src="/images/aadhaar-card.png" alt="" />
          <h3>This Aadhaar number is associated with another existing account</h3>
          <p>
            Associated number <span>{openAadhaarModal?.mobileNo}</span>
          </p>
          <p>
            If you believe it belongs to you, kindly raise a dispute at{" "}
            <Link to="mailto:info@ramfincorp.com">info@ramfincorp.com</Link>
          </p>
        </div>
      </Drawer>
    </div>
  );
}
